export default __webpack_public_path__ + "static/media/circleTopicLight.867e5510.svg";